import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { pickupsApi } from '@/lib/api'
import type { PickupOptions } from '@/types'

export const pickupOptionsKeys = {
  all: ['pickup-options'] as const,
}

export function usePickupOptions(): UseQueryResult<PickupOptions> {
  return useQuery({
    queryKey: pickupOptionsKeys.all,
    queryFn: async () => {
      const res = await pickupsApi.getOptions()
      return res.data
    },
    staleTime: Infinity,
  })
}
